export const shouldRenderBenefitModal = ({
	isDismissed,
	bannerDismissedAt,
}: {
	isDismissed?: boolean;
	bannerDismissedAt?: number | null;
}) => {
	if (!bannerDismissedAt || isDismissed) {
		return false;
	}

	return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};
